declare global {
  interface Window {
    _env?: Record<string, string>;
  }
}

export function env(key: string): string | undefined {
  return window._env?.[key] ?? process.env[key];
}
